
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCellOff as ObiCellOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cell-off.js';
 
 
 

 
 export const ObiCellOff = createComponent({
   react: React,
   tagName: 'obi-cell-off',
   elementClass: ObiCellOffElement,
   events: {
     
   }
  });
 
 